import { IconProps } from './types';

const AgentPinIcon = (props: IconProps) => {
  const {
    width = '34',
    height = '52',
    fillColor = '#03631E',
    fillColor1 = '#43B062',
    fillColor2 = '#013C12'
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
    >
      <path
        d="M34 17C34 26.3888 17 51.1621 17 51.1621C17 51.1621 0 26.3888 0 17C0 7.61108 7.6112 -3.8147e-05 17 -3.8147e-05C26.3888 -3.8147e-05 34 7.61108 34 17Z"
        fill={fillColor}
      />
      <path
        d="M2.91378 18.4931C2.91378 10.3371 9.52558 3.72526 17.6816 3.72526C22.4491 3.72526 26.6879 5.98482 29.3881 9.49076C26.8379 5.06374 22.0583 2.08335 16.5824 2.08335C8.42638 2.08335 1.81458 8.69515 1.81458 16.8513C1.81458 20.2399 2.95675 23.3614 4.87612 25.8535C3.62792 23.6867 2.91378 21.1733 2.91378 18.4931Z"
        fill={fillColor1}
      />
      <path
        d="M12.9911 44.66C15.3075 48.5412 17.0002 51.1621 17.0002 51.1621C17.0002 51.1621 34.0002 26.3888 34.0002 17C34.0002 16.507 33.9746 16.0202 33.9334 15.5379C33.2624 18.1462 32.314 20.6858 31.1497 23.1095C27.932 29.8077 23.1732 34.0995 18.1049 39.5336C16.471 41.2853 14.7703 43.0176 12.9911 44.66Z"
        fill={fillColor2}
      />
    </svg>
  );
};

export default AgentPinIcon;
